import { render, staticRenderFns } from "./TemplatesSection.v2.vue?vue&type=template&id=66f0024d&scoped=true&"
import script from "./TemplatesSection.v2.vue?vue&type=script&lang=js&"
export * from "./TemplatesSection.v2.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesSection.v2.vue?vue&type=style&index=0&id=66f0024d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f0024d",
  null
  
)

export default component.exports